import { Reveal, Stagger, staggerItem } from "../components/Reveal";
import { motion } from "framer-motion";
import { AUDIENCES } from "../data/content";

export default function ParaQuien() {
  return (
    <section id="para-quien" data-testid="para-quien-section" className="py-24 md:py-36 bg-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-14">
          <p className="overline mb-6">
            <span className="text-[#D7C6A3]">07</span> &nbsp;/&nbsp; ¿Para quién es?
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-tight">
            Pensada para acompañar cada historia.
          </h2>
        </Reveal>

        <Stagger className="flex flex-wrap gap-3">
          {AUDIENCES.map(({ name, Icon }, i) => (
            <motion.div
              key={i}
              variants={staggerItem}
              data-testid={`audience-${i}`}
              className="group flex items-center gap-3 bg-white border border-[#EBEBEB] rounded-full pl-4 pr-6 py-3 hover:bg-[#A3B18A] transition-colors duration-500"
            >
              <span className="w-9 h-9 rounded-full bg-[#F6F1E7] group-hover:bg-white/20 flex items-center justify-center transition-colors duration-500">
                <Icon size={18} weight="light" className="text-[#8A9A6F] group-hover:text-white transition-colors duration-500" />
              </span>
              <span className="text-sm text-[#2D3732] group-hover:text-white transition-colors duration-500">
                {name}
              </span>
            </motion.div>
          ))}
        </Stagger>

        <Reveal delay={0.1}>
          <p className="font-display text-3xl md:text-4xl text-[#2D3732] mt-16 max-w-3xl leading-snug">
            Y cualquier persona que quiera{" "}
            <span className="text-[#8A9A6F] italic">organizar su salud.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
